const fakeData = [
  {
    id: 1,
    title: 'Listen, choose the correct pronunciation for ‘ed’.',
    subTitle: 'Nghe, chọn cách phát âm đúng của ‘ed’.',
    audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/817bcaef-35f3-43f6-9213-6eec28023703.mp3',
    question: '',
    type: 'OneChoice',
    answers: [
      { id: 1, answer: '/id/ ', isCorrect: false },
      { id: 2, answer: '/d/ ', isCorrect: true },
      { id: 3, answer: '/t/', isCorrect: false },
    ],
    settings: {
      answers: {
        direction: 'horizontal',
        bulletType: 'none',
        // bulletType: 'character',
        // bulletType: 'number',
      },
    },
  },
  {
    id: 2,
    title: 'Listen, choose the correct pronunciation for ‘ed’.',
    subTitle: 'Nghe, chọn cách phát âm đúng của ‘ed’.',
    audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/b0d0b575-c5c1-4950-a025-5f2e3f829058.mp3',
    question: '',
    type: 'OneChoice',
    answers: [
      { id: 1, answer: '/id/ ', isCorrect: false },
      { id: 2, answer: '/d/ ', isCorrect: false },
      { id: 3, answer: '/t/', isCorrect: true },
    ],
    settings: {
      answers: {
        direction: 'horizontal',
        bulletType: 'none',
        // bulletType: 'character',
        // bulletType: 'number',
      },
    },
  },
  {
    id: 3,
    title: 'Listen and choose the correct sound',
    subTitle: '(Nghe và chọn âm trong có từ)',
    audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/efbbb634-1558-4ec6-bd9e-915bdcd0eddf.mp3',
    question: '',
    type: 'OneChoice',
    answers: [
      { id: 1, answer: 'ch', isCorrect: false },
      { id: 2, answer: 'sh', isCorrect: true },
      { id: 3, answer: 'th', isCorrect: false },
    ],
    settings: {
      answers: {
        direction: 'horizontal',
        bulletType: 'none',
      },
    },
  },
  {
    id: 4,
    title: 'Listen and choose the correct sound',
    subTitle: '(Nghe và chọn âm trong có từ)',
    audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/da2abe59-50e0-42b8-aa4d-d3b9fa15bf2e.mp3',
    question: '',
    type: 'OneChoice',
    answers: [
      { id: 1, answer: 'ct', isCorrect: true },
      { id: 2, answer: 'er', isCorrect: false },
      { id: 3, answer: 'th', isCorrect: false },
    ],
    settings: {
      answers: {
        direction: 'horizontal',
        bulletType: 'none',
      },
    },
  },
  {
    id: 5,
    title: 'Listen and choose the correct sound',
    subTitle: '(Nghe và chọn âm trong có từ)',
    audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/ec1a9e7e-d2ce-482c-81d2-0711b8838b91.mp3',
    question: '',
    type: 'OneChoice',
    answers: [
      { id: 1, answer: 'l', isCorrect: false },
      { id: 2, answer: 'n', isCorrect: true },
      { id: 3, answer: 'j', isCorrect: false },
    ],
    settings: {
      answers: {
        direction: 'horizontal',
        bulletType: 'none',
      },
    },
  },
  {
    id: 6,
    title: 'Listen and choose the correct stress sound.',
    subTitle: 'Nghe và chọn đáp án đúng.',
    audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/5b8729a3-0a0a-49c0-8b6a-a8ca09e58a01.mp3',
    question: '',
    type: 'OneChoice',
    answers: [
      { id: 1, answer: 'ca’rrot', isCorrect: false },
      { id: 2, answer: '’carrot', isCorrect: true },
    ],
    settings: {
      answers: {
        direction: 'horizontal',
        bulletType: 'none',
        // bulletType: 'character',
        // bulletType: 'number',
      },
    },
  },
  {
    id: 7,
    title: 'Listen and choose the correct stress sound.',
    subTitle: 'Nghe và chọn đáp án đúng.',
    audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/2b81fe62-c703-4057-8d55-e25fd8fa8e93.mp3',
    question: '',
    type: 'OneChoice',
    answers: [
      { id: 1, answer: `'geography`, isCorrect: false },
      { id: 2, answer: `ge'ography`, isCorrect: true },
    ],
    settings: {
      answers: {
        direction: 'horizontal',
        bulletType: 'none',
        // bulletType: 'character',
        // bulletType: 'number',
      },
    },
  },
  {
    id: 8,
    title: 'Listen and choose the correct stress sound.',
    subTitle: 'Nghe và chọn đáp án đúng.',
    audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/4c59600e-7da2-4011-85a5-450d88ec2c40.mp3',
    question: '',
    type: 'OneChoice',
    answers: [
      { id: 1, answer: `tomor'row`, isCorrect: false },
      { id: 2, answer: `to'morrow`, isCorrect: true },
    ],
    settings: {
      answers: {
        direction: 'horizontal',
        bulletType: 'none',
        // bulletType: 'character',
        // bulletType: 'number',
      },
    },
  },
  {
    id: 9,
    title: 'Match the audio with the correct sentence',
    // title: 'Match the audio/picture with the correct sentence',
    subTitle: 'Nối tệp âm thanh với câu phù hợp',
    type: 'Matching',
    question: '',
    answers: [
      { id: 1, answer: 'hippo', isCorrect: true, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/14655748-d1c2-401a-9e35-023422e5a9f9.mp3' },
      { id: 2, answer: 'bear', isCorrect: true, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/11c5fedf-cd9e-426b-810f-85aaba584272.mp3' },
    ],
  },
  {
    id: 10,
    title: 'Match the audio with the correct sentence',
    // subTitle: 'Nối tệp âm thanh/hình ảnh với câu phù hợp',
    subTitle: 'Nối tệp âm thanh với câu phù hợp',
    type: 'Matching',
    question: '',
    answers: [
      { id: 1, answer: 'evening', isCorrect: true, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/006ef306-fde0-4dd5-80f2-1d4d0a54d6f3.mp3' },
      { id: 2, answer: 'America', isCorrect: true, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/e5c177ce-86a7-453d-8be8-47b6c950560d.mp3' },
    ],
  },
  {
    id: 11,
    title: 'Unscramble letters to make a completed words',
    subTitle: 'Sắp xếp lại các chữ cái để có từ đúng.',
    question: 'bear',
    type: 'Unscramble',
    imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/71/2010-kodiak-bear-1.jpg/1200px-2010-kodiak-bear-1.jpg',
    answer: 'bear',
    settings: {
      question: {
        // shuffedType: 'word',
        shuffedType: 'character',
      },
    },
  },
  {
    id: 12,
    title: 'Unscramble letters to make a completed words',
    subTitle: 'Sắp xếp lại các chữ cái để có từ đúng.',
    question: 'lion',
    type: 'Unscramble',
    imageUrl: 'https://media.istockphoto.com/photos/lion-panthera-leo-10-years-old-isolated-on-white-picture-id877369086?k=6&m=877369086&s=612x612&w=0&h=0BMW4rBBkmoiU0MdMEHN7Qk_lHatvMTeOcdsJHWV8-M=',
    answer: 'lion',
    settings: {
      question: {
        // shuffedType: 'word',
        shuffedType: 'character',
      },
    },
  },
  {
    id: 13,
    title: 'Unscramble letters to make a completed words',
    subTitle: 'Sắp xếp lại các chữ cái để có từ đúng.',
    question: 'cat',
    type: 'Unscramble',
    imageUrl: 'https://img.freepik.com/free-photo/cat-white-background_155003-15381.jpg?size=626&ext=jpg&ga=GA1.2.2026981598.1618099200',
    answer: 'cat',
    settings: {
      question: {
        // shuffedType: 'word',
        shuffedType: 'character',
      },
    },
  },
  {
    id: 14,
    title: 'Unscramble letters to make a completed words',
    subTitle: 'Sắp xếp lại các chữ cái để có từ đúng.',
    question: 'monkey',
    type: 'Unscramble',
    imageUrl: 'https://static9.depositphotos.com/1594920/1087/i/600/depositphotos_10873478-stock-photo-vervet-monkey-chlorocebus-pygerythrus.jpg',
    answer: 'monkey',
    settings: {
      question: {
        // shuffedType: 'word',
        shuffedType: 'character',
      },
    },
  },
  {
    id: 15,
    title: 'Box',
    subTitle: 'Sắp xếp lại các chữ cái để có từ đúng.',
    question: 'tomorrow',
    type: 'Unscramble',
    // imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/71/2010-kodiak-bear-1.jpg/1200px-2010-kodiak-bear-1.jpg',
    answer: 'tomorrow',
    settings: {
      question: {
        // shuffedType: 'word',
        shuffedType: 'character',
      },
    },
  },
  {
    id: 16,
    title: 'Box',
    subTitle: 'Sắp xếp lại các chữ cái để có từ đúng.',
    question: 'Vietnamese',
    type: 'Unscramble',
    // imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/71/2010-kodiak-bear-1.jpg/1200px-2010-kodiak-bear-1.jpg',
    answer: 'Vietnamese',
    settings: {
      question: {
        // shuffedType: 'word',
        shuffedType: 'character',
      },
    },
  },
  {
    id: 17,
    title: 'Listen to the audio and fill in blank the missing word',
    subTitle: 'Nghe và điền từ còn thiếu vào chỗ trống',
    question: '',
    type: 'FillWordInTheBlank',
    questionAudio: 'https://cloud.softech.cloud/storage/Data/Sentences/44c5a865-8c7e-4201-a9b6-dd66c2d8ae93.mp3',
    answers: [
      { id: 1, text: "hello, I'm Bill.", answer: 'hello' },
      { id: 2, text: "hi, Bill.", answer: 'hi' },
    ],
  },
  {
    id: 18,
    title: 'Listen to the audio and fill in blank the missing word',
    subTitle: 'Nghe và điền từ còn thiếu vào chỗ trống',
    question: '',
    type: 'FillWordInTheBlank',
    questionAudio: 'https://cloud.softech.cloud/storage/Data/Sentences/19a7de52-328e-4237-815c-61676b24ca71.mp3',
    answers: [
      { id: 1, text: "I brush my teeth in the morning.", answer: 'morning' },
      { id: 2, text: "He plays soccer in the afternoon.", answer: 'soccer' },
    ],
  },
  {
    id: 19,
    title: ' Choose the correct ordinal numbers.',
    subTitle: '(Chọn số thứ tự tương ứng)',
    question: 'Three => ?',
    type: 'OneChoice',
    answers: [
      { id: 1, answer: 'third', isCorrect: true },
      { id: 2, answer: 'first', isCorrect: false },
      { id: 3, answer: 'second', isCorrect: false },
    ],
  },
  {
    id: 20,
    title: 'Listen and choose the correct number',
    subTitle: 'Nghe và chọn số đúng',
    audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/ac7a5fa5-a77f-4bc2-8c09-5275766d75d0.mp3',
    question: '',
    type: 'OneChoice',
    answers: [
      { id: 1, answer: '60', isCorrect: true },
      { id: 2, answer: '46', isCorrect: false },
      { id: 3, answer: '16', isCorrect: false },
    ],
    settings: {
      answers: {
        direction: 'horizontal',
        bulletType: 'none',
        // bulletType: 'character',
        // bulletType: 'number',
      },
    },
  },
  {
    id: 21,
    title: 'Unscramble the words to make a meaningful sentence.',
    subTitle: 'Sắp xếp các từ để tạo thành câu hoàn chỉnh.',
    question: 'What are they doing?',
    type: 'Unscramble',
    answer: 'What are they doing?',
  },
  {
    id: 22,
    title: 'Unscramble the words to make a meaningful sentence.',
    subTitle: 'Sắp xếp các từ để tạo thành câu hoàn chỉnh.',
    question: 'I brush my teeth in the morning.',
    type: 'Unscramble',
    answer: 'I brush my teeth in the morning.',
  },
  {
    id: 23,
    title: 'Unscramble the words to make a meaningful sentence.',
    subTitle: 'Sắp xếp các từ để tạo thành câu hoàn chỉnh.',
    question: 'American is their mother tounge.',
    type: 'Unscramble',
    answer: 'American is their mother tounge.',
  },
  {
    id: 24,
    title: ' Choose the correct sentence.',
    subTitle: '(Chọn câu đúng)',
    question: '',
    type: 'OneChoice',
    answers: [
      { id: 1, answer: 'I will see you later', isCorrect: true },
      { id: 2, answer: 'I am see you later', isCorrect: false },
      { id: 3, answer: 'I are see you later', isCorrect: false },
      { id: 4, answer: 'I seeing you later', isCorrect: false },
    ],
  },
  {
    id: 25,
    title: ' Choose the correct sentence.',
    subTitle: '(Chọn câu đúng)',
    question: '',
    type: 'OneChoice',
    answers: [
      { id: 1, answer: 'He plays soccer in the afternoon.', isCorrect: true },
      { id: 2, answer: 'He plays soccer at the afternoon.', isCorrect: false },
      { id: 3, answer: 'He plays soccer on the afternoon.', isCorrect: false },
      { id: 4, answer: 'He plays soccer under the afternoon.', isCorrect: false },
    ],
  },
  {
    id: 26,
    title: ' Choose the correct form of the word',
    subTitle: '(Chọn dạng đúng của từ)',
    question: `How old ....... your brother? - He's ten.`,
    type: 'OneChoice',
    answers: [
      { id: 1, answer: 'are', isCorrect: false },
      { id: 2, answer: 'am', isCorrect: false },
      { id: 3, answer: 'is', isCorrect: true },
    ],
  },
  {
    id: 27,
    title: ' Choose the correct form of the word',
    subTitle: '(Chọn dạng đúng của từ)',
    question: 'What color ....... this schoolbag?',
    type: 'OneChoice',
    answers: [
      { id: 1, answer: 'is', isCorrect: true },
      { id: 2, answer: 'do', isCorrect: false },
      { id: 3, answer: 'are', isCorrect: false },
    ],
  },
  {
    id: 28,
    title: ' Choose the correct form of the verb ',
    subTitle: '(Chia dạng đúng của động từ)',
    question: "We can't go out now. It (rain) ___.",
    type: 'FillInTheBlank',
    answer: 'rains',
  },
  {
    id: 29,
    title: ' Choose the correct form of the verb ',
    subTitle: '(Chia dạng đúng của động từ)',
    question: "He is (ride) ___ a horse.",
    type: 'FillInTheBlank',
    answer: 'riding',
  },
  {
    id: 30,
    title: ' Choose the correct form of the verb ',
    subTitle: '(Chia dạng đúng của động từ)',
    question: "She is (cook) ___ dinner.",
    type: 'FillInTheBlank',
    answer: 'cooking',
  },

]
export default fakeData